/**
 * `/orca/v3/runs/` — every run. Registers the route eagerly with its guard and stylesheets;
 * the page itself is `index.lazy.tsx`, so nothing it renders lands in the
 * always-loaded chunk.
 *
 * @since 1.0.0
 */
import { createFileRoute } from "@tanstack/react-router";

import { v3BeforeLoad, v3Head } from "~/lib/v3-route.ts";

export const Route = createFileRoute("/orca/v3/runs/")({
  beforeLoad: v3BeforeLoad,
  head: v3Head,
});
